import React, { Fragment } from "react";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import FormHelperText from "@material-ui/core/FormHelperText";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import TableRow from "@material-ui/core/TableRow";
import DeleteIcon from "@material-ui/icons/Delete";
import {
  Button,
  ButtonGroup,
  Tooltip,
  Typography,
  Grid,
  CircularProgress,
} from "@material-ui/core";
import LaunchIcon from "@material-ui/icons/Launch";
import { Visibility, VisibilityOff } from "@material-ui/icons";

import IconButton from "@material-ui/core/IconButton";
import FirstPageIcon from "@material-ui/icons/FirstPage";
import KeyboardArrowLeft from "@material-ui/icons/KeyboardArrowLeft";
import KeyboardArrowRight from "@material-ui/icons/KeyboardArrowRight";
import LastPageIcon from "@material-ui/icons/LastPage";

const useStyles = makeStyles({
  root: {
    position: "relative",
    // maxWidth: '1800px',
    // width: '100%',
    // overflowX: 'scroll'
    // maxWidth: 1400,
    // margin: 'auto'
  },
  container: {
    // minWidth: '1600px',
    height: "calc(100vh - 300px)",
    overflowY: "scroll",
  },
  loadingWrapper: {
    background: "#fff",
    position: "absolute",
    zIndex: 1000,
    width: "100%",
    height: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  table: {},
  logoImage: {
    height: 80,
    width: 80,
    borderRadius: "100%",
    objectFit: "cover",
    marginRight: 16,
  },
  tableRightBorder: {
    borderWidth: 1,
    borderColor: "#dadada",
    borderStyle: "solid",
  },
});

export default function BranchListComponent({
  rows,
  itemsPerPage,
  onItemsPerPageChange,
  loading,
  page,
  onPageChange,
  paginatorOptions,
  handleProviderView,
  handleProviderVisibilityToggle,
  handleProviderDelete,
}) {
  const classes = useStyles();

  const handleChangePage = (_, newPage) => {
    onPageChange(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    onItemsPerPageChange(+event.target.value);
  };

  const onView = (id) => () => {
    handleProviderView(id.provider_id, 2, id.info.name);
  };
  const copyToClipboard = async (text) => {
    // Clipboard API not available
    if (!navigator.clipboard) {
      return;
    }
    try {
      await navigator.clipboard.writeText(text);
    } catch (err) {
      console.error("Failed to copy!", err);
    }
  };

  return (
    <Paper className={classes.root} elevation={0}>
      {loading && (
        <div className={classes.loadingWrapper}>
          <CircularProgress />
        </div>
      )}

      <TableContainer className={classes.container}>
        <Table className={classes.table} stickyHeader aria-label="sticky table">
          <TableHead>
            <TableRow>
              <TableCell>Actions </TableCell>
              <TableCell>Branch Name</TableCell>
              <TableCell>Branch ID</TableCell>
              <TableCell>Provider name</TableCell>
              <TableCell>Branch Address </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.length === 0 && (
              <div className={classes.loadingWrapper} style={{ zIndex: 888 }}>
                <Typography variant="h4">No results found</Typography>
              </div>
            )}
            {rows.map((row) => {
              return (
                <TableRow
                  hover
                  role="checkbox"
                  tabIndex={-1}
                  key={row._id}
                  style={{ background: row.visibility ? "#fff" : "#ddd" }}
                >
                  <TableCell style={{ minWidth: 150 }}>
                    <ButtonGroup style={{ display: "block", height: "100%" }}>
                      <Grid container>
                        <Grid item xs={12} style={{ marginBottom: 1 }}>
                          <Tooltip title="Open provider">
                            <Button
                              color="secondary"
                              onClick={onView(row)}
                              variant="contained"
                              disableElevation
                            >
                              <LaunchIcon />
                            </Button>
                          </Tooltip>
                        </Grid>
                      </Grid>
                    </ButtonGroup>
                  </TableCell>
                  <TableCell style={{ minWidth: 250 }}>
                      <Typography>{row?.info?.name}</Typography>
                  </TableCell>
                  <TableCell style={{ minWidth: 250 }}>
                    {row._id}
                  </TableCell>
                  {/* <TableCell style={{ minWidth: 200 }}>
                    {row?.info?.category?.name}
                  </TableCell> */}
                  <TableCell style={{ minWidth: 200 }}>
                    {row?.provider_id?.info?.name}
                  </TableCell>

                  <TableCell style={{ minWidth: 250 }}>
                  {[
                      row?.info?.address?.address_line_1,
                      row?.info?.address?.street,
                      row?.info?.address?.landmark,
                      row?.info?.address?.city,
                      row?.info?.address?.state,
                      row?.info?.address?.country,
                      row?.info?.address?.zipCode,
                    ]
                      .filter((e) => !!e)
                      .map(
                        (text, i) =>
                          !!text && (
                            <Fragment key={text}>
                              {!!i && <br />}
                              {text}
                            </Fragment>
                          )
                      )}
                  </TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
      <div style={{ display: "flex", alignItems: "center" }}>
        <div style={{ paddingLeft: 16 }}>
          Rows per page
          <Select
            labelId="demo-simple-select-label"
            id="demo-simple-select"
            value={paginatorOptions.limit || 25}
            onChange={(e) => onItemsPerPageChange(e.target.value)}
            style={{ width: 64, marginLeft: 8 }}
          >
            {[25, 50, 100].map((count) => (
              <MenuItem value={count} key={count}>
                {count}
              </MenuItem>
            ))}
          </Select>
        </div>
        <div style={{ padding: "0 16px", flex: "1", textAlign: "center" }}>
          {paginatorOptions.pagingCounter} -{" "}
          {Math.min(
            paginatorOptions.pagingCounter + paginatorOptions.limit - 1,
            paginatorOptions.totalDocs
          )}{" "}
          of {paginatorOptions.totalDocs}
        </div>
        <div className={classes.paginatorActions}>
          <IconButton
            onClick={() => onPageChange(1)}
            disabled={!paginatorOptions.hasPrevPage}
            aria-label="first page"
          >
            <FirstPageIcon />
          </IconButton>
          <IconButton
            onClick={() => onPageChange(Math.max(1, page - 1))}
            disabled={!paginatorOptions.hasPrevPage}
            aria-label="first page"
            aria-label="previous page"
          >
            <KeyboardArrowLeft />
          </IconButton>
          <IconButton
            onClick={() => onPageChange(page + 1)}
            disabled={!paginatorOptions.hasNextPage}
            aria-label="next page"
          >
            <KeyboardArrowRight />
          </IconButton>
          <IconButton
            disabled={!paginatorOptions.hasNextPage}
            onClick={() =>
              onPageChange(
                Math.max(
                  0,
                  Math.ceil(paginatorOptions.totalDocs / paginatorOptions.limit)
                )
              )
            }
            aria-label="last page"
          >
            <LastPageIcon />
          </IconButton>
        </div>
      </div>
    </Paper>
  );
}
